import { isUndefined } from 'lodash';
import { Loader } from 'components/Loader';
import { DailyRoutineUI } from 'domains/dailyRoutines/Page/ui';
import { DailyRoutineCtx } from 'domains/dailyRoutines/context';
import { useDailyRoutine } from 'domains/dailyRoutines/data';
import { DAILY_ROUTINE_STEPPER_TITLE_IDS } from 'domains/dailyRoutines/steps';
import { useCompletableWizard } from 'utils/hooks/useCompletableWizard';
import { AssignmentFeedback } from 'domains/assignments/types';

type Props = {
  dailyRoutineId: string;
  learningPathId: string;
  onSubmit: (feedback: AssignmentFeedback) => void;
  previewMode?: boolean;
};

export const DailyRoutine: React.FC<Props> = ({ dailyRoutineId, learningPathId, onSubmit, previewMode = false }) => {
  const { data, error, isLoading: isLoadingContent } = useDailyRoutine(dailyRoutineId, learningPathId);

  const wizard = useCompletableWizard(Object.keys(DAILY_ROUTINE_STEPPER_TITLE_IDS).length);

  if (isLoadingContent) {
    return <Loader defaultStyles />;
  }

  if (isUndefined(data)) {
    throw new Error(`Failed to fetch data for ADL ID: ${dailyRoutineId}. Error was ${error}`);
  }

  const [learningPathContent, adlContent] = data;

  return (
    <DailyRoutineCtx.Provider
      value={{
        ...wizard,
        dailyRoutineContent: adlContent,
        learningPathContent,
        previewMode,
        onComplete: onSubmit,
      }}
    >
      <DailyRoutineUI />
    </DailyRoutineCtx.Provider>
  );
};

export default DailyRoutine;
